// 不需要校验token的接口
import {getCurrentLanguages} from "~/utils/I18nUtils";
import { useCrossDomainCookie } from "@/composables/useCrossDomainCookie";
const { createCrossDomainCookie } = useCrossDomainCookie();
// const lang = useCookie('lang',{
//    maxAge: 365 * 24 * 60 * 60 - 60 // 设置有效期
// });
const noTokenPath = {
   "/login": true,
   "/download": true,
   "/": true
}

const languageRoute = {
   "/zh": 'zh',
   "/en": 'en',
   "/ja": 'ja',
   "/zh-TW": 'zh-TW',
   "/ko": 'ko',
   "/hi": 'hi',
   "/ar": 'ar',
   "/de": 'de',
   "/fr": 'fr',
   "/id": 'id',
   "/itb": 'itb',
   "/uk": 'uk'
}
export default defineNuxtRouteMiddleware((to, from)=>{
   
   // if (to.params._lang && languageRoute[String(to.params._lang)]) {
   //    // useCookie('lang').value = String(to.params._lang)
   //    createCrossDomainCookie('lang', String(to.params._lang))
   //    console.log("langs===111", useCookie('lang').value)
   //    return ;
   // }
   // let lang = getCurrentLanguages()
   
   let router = useRouter()
   // 增加处理，如果直接访问路由以 / 结尾 ，则去掉 /再访问，否则nuxt3 的路由规则会找不当前页面
   if (to.fullPath.endsWith('/') && to.fullPath.length > 1) {
      to.path = to.path.slice(0, -1)
   }
   let pathToName =  "_lang" + (to.path == "/" ? "-index" : to.path.replace(/\//g, "-"))
   console.log("pathToName===", to.path, to.fullPath)
  
   if (to.path) {
      Object.keys(languageRoute).forEach(key => {
         if (to.path.startsWith(key)) {
            createCrossDomainCookie('lang', languageRoute[key])
         }
      })
   }
   // return navigateTo(`/${to.fullPath}`);
})
